import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/',
  headers: { 'ngrok-skip-browser-warning': 'True' },
});

export default apiClient;

export const timeouts = {
    simpleOperationsTimeout: 10_000,
    mediumOperationsTimeout: 25_000,
    complexOperationsTimeout: 600_000,
} as const;
